var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"online-video text-center"},[_c('youtube',{ref:"live",attrs:{"video-id":_vm.videoId,"allowfullscreen":"","player-vars":{ autoplay: 1, rel: 0, controls: 0 },"player-height":"650px","player-width":"100%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }